jQuery(document).ready(function ($) {
    ContagemLeituraPosts();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if(urlParams.get('preview')!="true")

    jQuery.ajax({
      url: countHandler.url+"/"+$('#main_post').attr('main-id')+"/"+Date.now(),
      type: 'POST',
      data: {
      },
      success: function(response) {
      },
      error: function(data) {
      }
    });
});

function ContagemLeituraPosts() {
    dataLayer.push({
        'event': 'ga_event',
        'eventCategory': "Categoria",
        'eventAction': "View - " + post_info.categories['category'],
        'eventLabel': post_info.categories['subcategory']
    });

    gtag('event', 'Categoria', {
        'eventAction': "View - " + post_info.categories['category'],
        'eventLabel': post_info.categories['subcategory']
    });
}

/*
* Evento de clique em Palavra Chave
*/
$('#post_keyword').on('click', function() {
    dataLayer.push({
        'event': 'ga_event',
        'eventCategory': 'Post',
        'eventAction': 'Clique - Palavra Chave',
        'eventLabel': $(this).text()
    });

    gtag('event', 'Post', {
        'eventAction': 'Clique - Palavra Chave',
        'eventLabel': $(this).text()
    });
});
